module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Light.7566461d.woff";